export type ChartTheme = "light" | "dark";

export interface ThemeColors {
  background: string;
  labels: string;
  grid: string;
  title: string;
  subtitle: string;
  axisTitles: string;
  series: string[];
}

export const chartColors = {
  light: {
    background: "#fcfcfc",
    labels: "#a6a6a6",
    grid: "#e3e3e8",
    title: "#333333",
    subtitle: "#595959",
    axisTitles: "#737373",
  },
  dark: {
    background: "#01232d",
    labels: "#a9aec3",
    grid: "#2a3d4a",
    title: "#e6e8f0",
    subtitle: "#a9aec3",
    axisTitles: "#758696",
  },
} as const;

export const chartSeriesColors = {
  light: {
    color0: "#1f8a82",
    color1: "#3e6fcc",
    color2: "#b3682e",
    color3: "#6a3fd6",
    color4: "#b25ab0",
    color5: "#b94752",
    color6: "#3e9e4f",
  },
  dark: {
    color0: "#85d7bf",
    color1: "#6ceeff",
    color2: "#ffd966",
    color3: "#b87df9",
    color4: "#f27d7f",
    color5: "#a5ffe5",
    color6: "#7391c9",
  },
} as const;

export const heatmapColors = {
  stops: {
    stop0: { position: 0.2, color: "#bedbff" },
    stop1: { position: 0.4, color: "#51a2ff" },
    stop2: { position: 0.6, color: "#155cfc" },
    stop3: { position: 0.9, color: "#1347e6" },
  },
  borderColor: "#FFFFFF",
  labelColor: {
    light: "#000000",
    dark: "#FFFFFF",
  },
} as const;

export const chartThemes: Record<ChartTheme, ThemeColors> = {
  light: {
    ...chartColors.light,
    series: Object.values(chartSeriesColors.light),
  },
  dark: {
    ...chartColors.dark,
    series: Object.values(chartSeriesColors.dark),
  },
};
